module.exports = __webpack_public_path__ + "img/top_reight.1ffb60ed.svg";